import { render, staticRenderFns } from "./DisabledPOP.vue?vue&type=template&id=ec09d072&scoped=true"
import script from "./DisabledPOP.vue?vue&type=script&lang=js"
export * from "./DisabledPOP.vue?vue&type=script&lang=js"
import style0 from "./DisabledPOP.vue?vue&type=style&index=0&id=ec09d072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec09d072",
  null
  
)

export default component.exports